// extracted by mini-css-extract-plugin
export default {"instantPriceButton":"xVlpxDIrHTUTbAxtKMnC","instantPriceButtonLoader":"QIAns73zTfFSlBzPpZIN"};